import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router';

import OverviewTable from '../../../components/OverviewTable/OverviewTable';
import rbacCheck from '../../../rbac/rbacCheck';
import OrganizationBreadCrumb from '../OrganizationBreadCrumb';

import MarketplaceItems from './MarketplaceItems';

import GitlabWikiHelpButton from '@/components/GitlabWikiHelpButton';
import type { Organization } from '@/types/organization';
import type { OverviewTableRow } from '@/types/tableTypes';
import type { User } from '@/types/user';

const usersGuideSlug = 'user-guide/organizations/overview';

interface RootState {
  user: User;
}

const Overview = (): React.ReactElement => {
  const user = useSelector((state: RootState) => state.user);

  const [organization, setOrganization] =
    useOutletContext<[Organization, (org: Organization) => void]>();

  const isAdminOrg = organization.enterpriseName.trim().toLowerCase() === 'admin-org';

  const canSeeMarketplace: boolean = rbacCheck(user.roles, '/marketplace:VIEW') as boolean;
  const canActivateMarketplace: boolean = rbacCheck(user.roles, '/marketplace:PUT') as boolean;

  const rows: OverviewTableRow[] = [
    {
      title: { id: 'crmId' },
      value: organization.CRMId ?? '',
    },
    {
      title: { id: 'accountOwner' },
      value: organization.accountOwner?.email ?? '',
    },
  ];

  return (
    <>
      <OrganizationBreadCrumb />
      <Grid
        container
        direction='column'
        rowGap={8}
      >
        <Grid item>
          <OverviewTable
            header={organization.enterpriseName}
            rows={rows}

            trailingActionSlot={
              <GitlabWikiHelpButton
                slug={usersGuideSlug}
                tooltipMessageId='usersGuide'
                tooltipDefaultMessage='Users guide'
                modalTitleMessageId='usersGuide'
                modalTitleDefaultMessage='Users guide'
                buttonAriaLabel='Open users guide'
                buttonSx={{ mt: 0 }}
              />
            }
          />
        </Grid>
        {canSeeMarketplace && !isAdminOrg && (
          <Grid item>
            <MarketplaceItems
              organization={organization}
              setOrganization={setOrganization}
              canActivate={canActivateMarketplace}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default Overview;
